import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// ===== 样式文件导入 =====
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.less'

// ===== 第三方库导入 =====
import ElementUI, { Message } from 'element-ui'
import moment from 'moment'
import VueClipboard from 'vue-clipboard2'

// ===== 工具类和配置导入 =====
import common from './utils/common'
import './utils/atomic'
import Api from './api/index'
import Config from './api/config'
import { THEMES } from './store/modules/app'

// ===== 主题应用函数 =====
function applyTheme(themeKey) {
  const theme = THEMES.find(t => t.key === themeKey) || THEMES[0]
  const root = document.documentElement
  // hex 转 rgb 三元组
  function hexToRgb(hex) {
    const h = hex.replace('#', '')
    const r = parseInt(h.substring(0, 2), 16)
    const g = parseInt(h.substring(2, 4), 16)
    const b = parseInt(h.substring(4, 6), 16)
    return `${r}, ${g}, ${b}`
  }
  // 主色系
  root.style.setProperty('--primary', theme.primary)
  root.style.setProperty('--primary-rgb', hexToRgb(theme.primary))
  root.style.setProperty('--primary-hover', theme.primaryDark || theme.primary)
  root.style.setProperty('--primary-dark', theme.primaryDark || theme.primary)
  root.style.setProperty('--primary-light', theme.primaryLight || theme.primary + '20')
  // 强调色（跟随主色）
  root.style.setProperty('--accent', theme.accent || theme.primary)
  // 背景
  root.style.setProperty('--bg-page', theme.bgPage)
  root.style.setProperty('--bg-gradient-start', theme.bgGradientStart || theme.primaryLight)
  root.style.setProperty('--bg-gradient-end', theme.bgGradientEnd || theme.primary + '20')
  // 导航高亮（科技蓝导航用橙色，暖橙用橙色）
  root.style.setProperty('--nav-active', theme.navActive)
  root.style.setProperty('--nav-avatar-bg', theme.primaryLight || theme.primary + '15')
  // 边框主色
  root.style.setProperty('--border-primary', theme.primaryLight || theme.primary + '20')
  root.removeAttribute('data-theme')
}

// 全局挂载主题方法
Vue.prototype.$applyTheme = applyTheme

// ===== 初始化配置 =====
Vue.config.productionTip = false

// 全局属性挂载
Vue.prototype.$common = common
Vue.prototype.$Api = Api
Vue.prototype.$Config = Config
Vue.prototype.$moment = moment

// 插件使用
Vue.use(ElementUI)
Vue.use(VueClipboard)

const normalizeMessageOptions = options => {
  if (typeof options === 'string') {
    return { message: options }
  }
  return options && options._isVNode ? { message: options } : { ...(options || {}) }
}

const closableMessage = options => Message({
  ...normalizeMessageOptions(options),
  showClose: true
})

;['success', 'warning', 'info', 'error'].forEach(type => {
  closableMessage[type] = options => Message({
    ...normalizeMessageOptions(options),
    type,
    showClose: true
  })
})
closableMessage.closeAll = Message.closeAll
Vue.prototype.$message = closableMessage

// 导入权限控制
import '@/permission'
import './command';
// 启动时应用已保存的主题
const savedTheme = localStorage.getItem('themeKey')
// 兼容旧 key: 'orange' -> 'default'
if (savedTheme === 'orange') {
  localStorage.setItem('themeKey', 'default')
  applyTheme('default')
} else if (savedTheme && THEMES.find(t => t.key === savedTheme)) {
  applyTheme(savedTheme)
} else {
  applyTheme('default')
}

// ===== 应用启动 =====
const vueInstance = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Vue 挂载完成后，重新扫描所有 DOM 以确保原子样式完整生成
vueInstance.$nextTick(() => {
  if (typeof window.__atomicRescan === 'function') {
    window.__atomicRescan()
  }
})
